import React, { useRef, useState } from "react";
import "./pvx.css";
import ContactUs from "../Components/contactUs";
import Navbar from "../Components/navbar";
import Provider from "./Components/provider";
import PVXFAQs from "./Components/pvxFAQs";
import { ArrowRight, Fullscreen } from "@mui/icons-material";
import Carousel from "react-bootstrap/Carousel";
import TrialBtn from "./Components/trialBtn";

const PVX = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [fullScreen, setFullScreen] = useState(false);

  const providers = [
    {
      vid: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Financial_1778496904883.mp4",
      main: "Detail and Consumption",
      sub: "PVX's workflow starts with a design page where users input customer and site information. Integrating Google Maps allows for simplified roof selection by pinpointing the exact location. Users can zoom and pan to select their desired roof type. After defining the site, users proceed to the consumption section. This section offers a range of pre-defined consumption profiles, which can be further customized by manually adjusting monthly consumption values.",
    },
    {
      vid: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/undefined_1778496964162.mp4",
      main: "Design",
      sub: "Following the consumption phase, the design page enables solar PV system layout. First, select the previously chosen location and mark the desired roof area. After defining the roof, add any necessary obstacles. Then, choose a roof type and select a structure from the list, or opt for a custom structure for detailed adjustments. Finally, configure Azimuth, Tilt, and building orientation. The design page also supports the design of multiple roofs within the same location.",
    },
    {
      vid: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/undefined_1778496727335.mp4",
      main: "Electrical Configuration",
      sub: "Once the mechanical layout is finalized, the electrical system design phase begins. Start by selecting the system type, which includes On-grid, Hybrid, and Off-grid options. Next, define the desired DC/AC ratio. Then, choose the appropriate inverter model, inverter type, and any other required accessories. If the system involves multiple roofs, you have the flexibility to design the electrical components for each roof independently and then combine them into a unified electrical system.",
    },
    {
      vid: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Financial_1778497169031.mp4",
      main: "Financial",
      sub: "Once you have finalized your system design, encompassing consumption profiles, mechanical layout, and electrical configuration, you can proceed to the financial analysis. Begin by specifying the desired payback period for the system. Subsequently, input all relevant financial values, including the total system cost, the anticipated annual cost increase, and the ongoing operation and maintenance (O&M) costs.",
    },
    {
      vid: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/undefined_1778496792426.mp4",
      main: "Summary",
      sub: "The Summary area provides a complete compilation of the system design, presenting all entered data in a unified view. This includes a comprehensive equipment list and a detailed Bill of Quantities (BOQ) for the site. The Report section allows you to generate a fully detailed report, which you can personalize with your company logo and name. This report covers a wide range of information, including basic site details, specific side details, the mechanical and electrical layout of the system, a solar shading analysis, and a summary of the environmental benefits achieved.",
    },
  ];

  const data = [
    {
      src: "https://pvx-images.s3.me-south-1.amazonaws.com/LandingPageCarouse1_1742452276542.jpg",
      title: "LandingPageCarouse1",
    },
    {
      src: "https://pvx-images.s3.me-south-1.amazonaws.com/LandingPageCarouse2_1742374324962.png",
      title: "LandingPageCarouse2",
    },
    {
      src: "https://pvx-images.s3.me-south-1.amazonaws.com/LandingPageCarousel3_1742375342181.png",
      title: "LandingPageCarouse3",
    },
  ];

  const togglePlayPause = () => {
    const video = videoRef.current;
    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  const toggleFullScreen = () => {
    if (videoRef.current) {
      if (videoRef.current.requestFullscreen) {
        videoRef.current.requestFullscreen();
      } else if (videoRef.current.webkitRequestFullscreen) {
        videoRef.current.webkitRequestFullscreen();
      } else if (videoRef.current.mozRequestFullScreen) {
        videoRef.current.mozRequestFullScreen();
      } else if (videoRef.current.msRequestFullscreen) {
        videoRef.current.msRequestFullscreen();
      }
    }
  };

  return (
    <>
      <Navbar />
      {/* Hero Section */}
      <Carousel>
        {data.map((item) => (
          <Carousel.Item interval={2000}>
            <img
              className="d-block w-100 carouselImage"
              src={item.src}
              alt={item.title}
            />
          </Carousel.Item>
        ))}
      </Carousel>
      {/* Features Balls */}
      <div className="pvx-feature-balls">
        <div className="ball-div">
          <img src="./images/PVX/Ball1.svg" alt="Ball1" />
          <div className="text">Swift and precise 3D designs</div>
        </div>
        <div className="ball-div">
          <img src="./images/PVX/Ball2.svg" alt="Ball2" />
          <div className="text">Tailored interactive proposals</div>
        </div>
        <div className="ball-div">
          <img src="./images/PVX/Ball3.svg" alt="Ball3" />
          <div className="text">Achieve elevated sales conversion rates</div>
        </div>
      </div>
      {/* Provider Section */}
      <div className="pvx-providers">
        {providers.map((provider, index) => (
          <Provider
            key={index}
            vid={provider.vid}
            main={provider.main}
            sub={provider.sub}
            dir={index % 2 !== 0}
          />
        ))}
      </div>
      {/* Why */}
      <div className="pvx-why">
        <div className="content">
          <div className="main">
            Why Smith PV-X?
            <img
              src="./images/PVX/Line3.svg"
              className="underline"
              alt="Line"
            />
          </div>
          <div className="sub">
            With our design tool, you or your client have the possibility to
            design a desired substructure for a building. The design tool can be
            used to define roofs with various properties, such as roof pitch,
            roof covering or even interfering surfaces.
          </div>
        </div>
        <img src="./images/PVX/Why.svg" className="image" alt="Why" />
      </div>
      {/* How */}
      <div className="pvx-how">
        <div className="content">
          <div className="main">
            How to use PV-X?
            <img
              src="./images/PVX/Line3.svg"
              className="underline"
              alt="Line"
            />
          </div>
          <div className="sub">
            With our design tool, you or your client have the possibility to
            design a desired substructure for a building. The design tool can be
            used to define roofs with various properties, such as roof pitch,
            roof covering or even interfering surfaces.
          </div>
        </div>

        <div className="pvx-provider">
          <div className="vidBox">
            <div className="vidBG"></div>
            <video
              ref={videoRef}
              className="vid"
              poster="https://smithpvx.s3.ap-southeast-1.amazonaws.com/undefined_1778498012081.jpeg"
              onClick={togglePlayPause}
              onMouseEnter={() => setFullScreen(true)}
              onMouseLeave={() => setFullScreen(false)}
            >
              <source
                src={
                  "https://smithpvx.s3.ap-southeast-1.amazonaws.com/undefined_1778497259883.mp4"
                }
                type={"video/mp4"}
              />
              Your browser does not support the video tag.
            </video>

            {/* Video Controls  */}
            {!isPlaying && (
              <div className="pauseBtn">
                <div className="btnRing">
                  <ArrowRight onClick={togglePlayPause} />
                </div>
              </div>
            )}
            {fullScreen && isPlaying && (
              <div className="fsBtn">
                <Fullscreen
                  onClick={toggleFullScreen}
                  onMouseEnter={() => setFullScreen(true)}
                  onMouseLeave={() => setFullScreen(false)}
                />
              </div>
            )}
          </div>
        </div>
      </div>
   
      {/* Get in touch */}
      <div className="pvx-touch">
        <div className="content">
          <div className="main">
            Get in touch to discuss how we can help you!
          </div>
          <div className="sub">
            We're pleased to be welcoming customers to join us.
          </div>
          <div className="cta">Request a quote</div>
        </div>
        <img src="./images/PVX/SolarCircle.svg" alt="SolarCircle" />
      </div>
     
      <PVXFAQs />
      <ContactUs />
      <TrialBtn/>
    </>
  );
};

export default PVX;
